/**
 * Role hierarchy and permissions configuration
 */

// Role hierarchy - higher levels inherit all permissions of lower levels
export const ROLES_HIERARCHY = {
  admin: 3,
  manager: 2,
  staff: 1,
};

// Permission constants
export const PERMISSIONS = {
  // Staff management
  STAFF_CREATE: 'staff:create',
  STAFF_EDIT: 'staff:edit',
  STAFF_DELETE: 'staff:delete',
  STAFF_INVITE: 'staff:invite',
  STAFF_SUSPEND: 'staff:suspend',
  STAFF_RESET_PASSWORD: 'staff:reset_password',
  STAFF_CHANGE_ROLE: 'staff:change_role',
  STAFF_VIEW: 'staff:view',
  
  // Department management
  DEPARTMENT_CREATE: 'department:create',
  DEPARTMENT_EDIT: 'department:edit',
  DEPARTMENT_DELETE: 'department:delete',
  DEPARTMENT_VIEW: 'department:view',
  
  // Job title management
  JOB_TITLE_CREATE: 'job_title:create',
  JOB_TITLE_EDIT: 'job_title:edit',
  JOB_TITLE_DELETE: 'job_title:delete',
  JOB_TITLE_VIEW: 'job_title:view',
};

// Role permissions mapping
export const ROLE_PERMISSIONS = {
  admin: [
    PERMISSIONS.STAFF_CREATE,
    PERMISSIONS.STAFF_EDIT,
    PERMISSIONS.STAFF_DELETE,
    PERMISSIONS.STAFF_INVITE,
    PERMISSIONS.STAFF_SUSPEND,
    PERMISSIONS.STAFF_RESET_PASSWORD,
    PERMISSIONS.STAFF_CHANGE_ROLE,
    PERMISSIONS.STAFF_VIEW,
    PERMISSIONS.DEPARTMENT_CREATE,
    PERMISSIONS.DEPARTMENT_EDIT,
    PERMISSIONS.DEPARTMENT_DELETE,
    PERMISSIONS.DEPARTMENT_VIEW,
    PERMISSIONS.JOB_TITLE_CREATE,
    PERMISSIONS.JOB_TITLE_EDIT,
    PERMISSIONS.JOB_TITLE_DELETE,
    PERMISSIONS.JOB_TITLE_VIEW,
  ],
  manager: [
    PERMISSIONS.STAFF_CREATE,
    PERMISSIONS.STAFF_EDIT,
    PERMISSIONS.STAFF_DELETE,
    PERMISSIONS.STAFF_INVITE,
    PERMISSIONS.STAFF_SUSPEND,
    PERMISSIONS.STAFF_RESET_PASSWORD,
    PERMISSIONS.STAFF_VIEW,
    PERMISSIONS.DEPARTMENT_VIEW,
    PERMISSIONS.JOB_TITLE_VIEW,
  ],
  staff: [
    PERMISSIONS.STAFF_VIEW,
    PERMISSIONS.DEPARTMENT_VIEW,
    PERMISSIONS.JOB_TITLE_VIEW,
  ],
};